import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './ToggleButton.module.css'

export default class ToggleButton extends Component {
  static propTypes = {
    checked: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func
  }

  static defaultProps = {
    checked: false
  }  

  _onChange () {
    this.props.onChange(!this.props.checked)
  }

  render () {
    return (
      <div className={styles['toggle-button']}>
        <input
          checked={this.props.checked}
          id={this.props.name}
          name={this.props.name}
          onChange={this._onChange.bind(this)}
          className={styles['toggle-button-input']}
          type="checkbox"
        />
        <label 
          htmlFor={this.props.name} 
          className={styles['toggle-button-label']}
        />
      </div>
    )
  }
}
